import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import ImageComponent from '../Image/Image'
import styles from './PreviewImage.module.sass'
import placeholder from '../../assets/placeholder_elementary.png'
import { CustomerContext } from '../../contexts/CustomerContext'
import useLocalStorage from '../../hooks/useLocalStorage'
import NameOverlay from './NameOverlay'

const PreviewImage = ({
  actualForegroundUrl,
  foregroundUrl,
  backgroundUrl,
  containerClass,
  onLoad,
  classes,
  accessCodeOnly,
  isPreviewHidden,
  isResponsive = false,
  noTouchAction = false,
  backgroundClassName = null,
  style = {},
  nameForeground = null,
  nameFirstName = '',
}) => {
  const { customer: { currentSchool } } = useContext(CustomerContext)
  const [isUsingAccessCode] = useLocalStorage('isUsingAccessCode')

  let isAccessCodeOnly = accessCodeOnly
  if (isAccessCodeOnly === undefined) {
    isAccessCodeOnly = currentSchool ? currentSchool.accessCodeOnly : false
  }

  let previewHidden = isPreviewHidden
  if (previewHidden === undefined) {
    previewHidden = !isUsingAccessCode
  }

  const renderPlaceholder = isAccessCodeOnly && previewHidden
  const foreground = renderPlaceholder ? placeholder : foregroundUrl

  return (
    <div className={cn(containerClass || styles.container, classes, 'previewImage')} style={style}>
      {actualForegroundUrl && <ImageComponent noTouchAction={noTouchAction} src={actualForegroundUrl} classes={cn(styles.actualForeground)} />}
      {foregroundUrl && <ImageComponent noTouchAction={noTouchAction} src={foreground} onLoad={onLoad} classes={cn(styles.img, isResponsive && styles.responsive)} />}
      {backgroundUrl && foregroundUrl?.includes('.png') && <ImageComponent noTouchAction={noTouchAction} src={backgroundUrl} classes={cn(styles.img, styles.background, backgroundClassName)} />}
      {nameForeground && <NameOverlay foreground={nameForeground} firstName={nameFirstName} />}
    </div>
  )
}

PreviewImage.defaultProps = {
  classes: '',
  containerClass: '',
  accessCodeOnly: undefined,
  isPreviewHidden: undefined,
  foregroundUrl: null,
  backgroundUrl: null,
  onLoad: () => { },
  nameForeground: null,
  nameFirstName: '',
}

PreviewImage.propTypes = {
  foregroundUrl: PropTypes.string,
  backgroundUrl: PropTypes.string,
  classes: PropTypes.string,
  onLoad: PropTypes.func,
  accessCodeOnly: PropTypes.bool,
  containerClass: PropTypes.string,
  isPreviewHidden: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  nameForeground: PropTypes.object,
  nameFirstName: PropTypes.string,
}

export default PreviewImage
